<p-dialog [(visible)]="displayHelpPopUp" [header]="'Date Range'" dismissableMask="true" modal="true">
  <div style="font-weight: 500">
    <p>You can select a maximum of 5 consecutive calendar days.</p>
    <p>You must select the first and last day of your visit.</p>
  </div>
</p-dialog>
<div id="iframe-portalV1">
  <div class="container-fluid">
    <nav class="navbar navbar-expand navbar-light bg-light mb-3" id="breadcrumb-sf-1">
      <nav aria-label="breadcrumb" class="navbar-nav mr-auto">
        <ol class="breadcrumb ol-sf-1">
          <li class="breadcrumb-item">
            <a routerLink="/#">Home</a>
          </li>
          <li class="breadcrumb-item">
            <a *roles="['ROLE_MCKAY']" [routerLink]="'/hosting'">Hosting - Datacenter
              work visits history</a>
            <a *roles="['ROLE_CLIENT']" routerLink="/hosting">Hosting - Datacenter work visits history</a>
          </li>
          <li *ngIf="mode === 'edit'" aria-current="page" class="breadcrumb-item active">Edit</li>
          <li *ngIf="mode === 'show'" aria-current="page" class="breadcrumb-item active">Show</li>
          <li *ngIf="mode === 'new'" aria-current="page" class="breadcrumb-item active">New</li>
        </ol>
      </nav>
    </nav>
  </div>
  <div class="layout-main">
    <div class="container-fluid">
      <div *ngIf="loading" class="d-flex justify-content-center">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div *ngIf="!loading">
        <div *ngIf="error" class="alert alert-danger alert-dismissible fade show">
          {{ errorMessage }}
          <button (click)="error = false" aria-label="Close" class="close" type="button">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div *ngIf="success" class="alert alert-success alert-dismissible fade show">
          {{ successMessage }}
          <button (click)="success = false" aria-label="Close" class="close" type="button">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div>
          <div class="symbols-title-row">
            <h3 class="mb-0">
              <b *ngIf="mode === 'new'">Request a work visit</b>
              <b *ngIf="mode === 'edit'">Edit a work visit</b>
              <b *ngIf="mode === 'show'">Work visit to
                <a *roles="['ROLE_MCKAY']" pTooltip="Go to hosting manager assignment"
                   [href]="hostingManagerUrl + '/assignment/' + workVisit.assignment"
                   target="_blank">{{ this.getCabListString() }} <i class="fa fa-external-link"></i></a>
                <ng-container *roles="['ROLE_CLIENT']">{{ this.getCabListString() }}</ng-container>
              </b>
            </h3>
          </div>
          <div class="wv-layout">
            <div class="wv-main">
              <form>
                <div class="wv-section">
                  <div class="wv-section-header">Visit details</div>
                  <div class="wv-section-body">

                    <div class="field-group">
                      <label>Half cab</label>
                      <p-multiSelect (onChange)="onChangeMultiSelect($event)" [(ngModel)]="selectedOptions"
                                     [disabled]="mode === 'show'"
                                     [filter]="false"
                                     [options]="cabsOptions"
                                     [scrollHeight]="'400px'"
                                     [showHeader]="false"
                                     [showToggleAll]="true" appendTo="body" panelStyleClass="sym-select-panel wv-cab-panel"
                                     placeholder="Select items"
                                     name="cabinet">
                        <ng-template pTemplate="selectedItems">
                          <span>{{ getSelectedItemsLabel() }}</span>
                        </ng-template>
                        <ng-template let-option pTemplate="item">
                          <div class="wv-cab-group">
                            <span class="wv-cab-group-label">{{ option.label }}</span>
                            <div (click)="onClickChildOptionContainer($event)"
                                 *ngFor="let childOption of option.value.childOptions"
                                 class="wv-cab-checkbox-row">
                              <p-checkbox (onChange)="onChangeChildOptionCheckbox(option)"
                                          [(ngModel)]="option.value.selectedChildOptions"
                                          [value]="childOption.value"
                                          label=" {{childOption.label}}"
                                          name="{{option.label}}"></p-checkbox>
                            </div>
                          </div>
                        </ng-template>
                      </p-multiSelect>
                    </div>

                    <div class="wv-field-label">Visitors names and emails</div>
                    <div class="two-col-grid">
                      <div class="field-group">
                        <label>Name</label>
                        <input [(ngModel)]="workVisit.visitors[0].name" (ngModelChange)="this.formPrestine = false;"
                               [disabled]="mode === 'show'"
                               class="form-control"
                               name="name0"
                               placeholder="Name"/>
                      </div>
                      <div class="field-group">
                        <label>Email</label>
                        <input [(ngModel)]="workVisit.visitors[0].email" (ngModelChange)="this.formPrestine = false;"
                               [disabled]="mode === 'show'"
                               [ngClass]="{ 'invalid-email': workVisit.visitors[0].email && !isEmailValid(workVisit.visitors[0].email) }"
                               class="form-control"
                               name="email0"
                               placeholder="Email"
                               type="email"/>
                      </div>
                    </div>
                    <div *ngIf="mode !== 'show' || workVisit.visitors[1].name !== ''" class="two-col-grid">
                      <div class="field-group">
                        <label>Name</label>
                        <input [(ngModel)]="workVisit.visitors[1].name" (ngModelChange)="this.formPrestine = false;"
                               [disabled]="mode === 'show'"
                               class="form-control"
                               name="name1"
                               placeholder="Name"/>
                      </div>
                      <div class="field-group">
                        <label>Email</label>
                        <input [(ngModel)]="workVisit.visitors[1].email" (ngModelChange)="this.formPrestine = false;"
                               [disabled]="mode === 'show'"
                               [ngClass]="{ 'invalid-email': workVisit.visitors[1].email && !isEmailValid(workVisit.visitors[1].email) }"
                               class="form-control"
                               name="email1"
                               placeholder="Email"
                               type="email"/>
                      </div>
                    </div>
                    <div *ngIf="mode !== 'show' || workVisit.visitors[2].name !== ''" class="two-col-grid">
                      <div class="field-group">
                        <label>Name</label>
                        <input [(ngModel)]="workVisit.visitors[2].name" (ngModelChange)="this.formPrestine = false;"
                               [disabled]="mode === 'show'"
                               class="form-control"
                               name="name2"
                               placeholder="Name"/>
                      </div>
                      <div class="field-group">
                        <label>Email</label>
                        <input [(ngModel)]="workVisit.visitors[2].email" (ngModelChange)="this.formPrestine = false;"
                               [disabled]="mode === 'show'"
                               [ngClass]="{ 'invalid-email': workVisit.visitors[2].email && !isEmailValid(workVisit.visitors[2].email) }"
                               class="form-control"
                               name="email2"
                               placeholder="Email"
                               type="email"/>
                      </div>
                    </div>

                    <div class="field-group">
                      <label>
                        <ng-container *roles="['ROLE_CLIENT']">Your</ng-container>
                        <ng-container *roles="['ROLE_MCKAY']">Customer</ng-container>
                        comment
                      </label>
                      <textarea [(ngModel)]="workVisit.clientComment" (ngModelChange)="this.formPrestine = false;"
                                [disabled]="mode === 'show'"
                                class="form-control"
                                name="client-comment"
                                rows="4">
                      </textarea>
                    </div>

                  </div>
                </div>

                <div class="wv-section">
                  <div class="wv-section-header">Dates &amp; times</div>
                  <div class="wv-section-body">

                    <div class="field-group">
                      <label>
                        Date range
                        <i (click)="alterDisplayHelpPopUp()" class="fa fa-question-circle symbols-help"></i>
                      </label>
                      <input
                        [(ngModel)]="dateRange"
                        (datesUpdated)="onDateSelect($event)"
                        [autoApply]="true"
                        [dateLimit]="4"
                        [disabled]="mode === 'show'"
                        [locale]="{format: 'DD/MM/YYYY'}"
                        [minDate]="minDate"
                        class="form-control"
                        name="startDate"
                        ngxDaterangepickerMd
                        type="text"
                      />
                    </div>

                    <ng-container *ngIf="dates.length > 0">
                      <div class="schedule-col-headers">
                        <span class="schedule-col-label">Day</span>
                        <span class="schedule-col-label">Start time</span>
                        <span class="schedule-col-label">End time</span>
                        <span></span>
                      </div>
                      <div class="schedule-row" *ngFor="let date of dates; index as i">
                        <span class="schedule-label">{{ formatEtDay(date) }} ({{ getEasternAbbr(date, startTimes[i]) }})</span>
                        <p-calendar #startTimeCalendar
                                    [(ngModel)]="startTimes[i]"
                                    (ngModelChange)="this.formPrestine = false;"
                                    [dateFormat]="'iso'" [disabled]="mode === 'show'"
                                    [hideOnDateTimeSelect]="false" [timeOnly]="true"
                                    dataType="date" appendTo="body" panelStyleClass="sym-datepicker"
                                    styleClass="wv-time-input"
                                    id="start_time_{{i}}" name="start_time_{{i}}"></p-calendar>
                        <p-calendar #endTimeCalendar [(ngModel)]="endTimes[i]"
                                    [disabled]="mode === 'show'" [hideOnDateTimeSelect]="false"
                                    (ngModelChange)="this.formPrestine = false;"
                                    [timeOnly]="true" dataType="date" appendTo="body" panelStyleClass="sym-datepicker"
                                    styleClass="wv-time-input"
                                    id="end_time_{{i}}"
                                    name="end_time_{{i}}"></p-calendar>
                        <a class="wv-copy-time" (click)="copyTime()" *ngIf="mode !== 'show' && i === 0">
                          <i aria-hidden="true"
                             class="fa fa-copy"
                             pTooltip="Copy Start time and End time from the first day's hours to all other days."
                          ></i>
                        </a>
                      </div>
                    </ng-container>

                  </div>
                </div>
              </form>
            </div>

            <div *ngIf="mode !== 'new'" class="wv-side">
              <div class="wv-section">
                <div class="wv-section-header">Status</div>
                <div class="wv-section-body wv-fact-grid">
                  <div class="fact-row"><span class="k">Status</span><span class="v">{{ workVisit.status }}</span></div>
                  <div class="fact-row" *ngIf="workVisit.status && workVisit.status !== 'Draft'">
                    <span class="k">Jira ticket</span>
                    <span class="v"><a [href]="getJiraLink(workVisit.jiraIssue)">{{ workVisit.jiraIssue }}</a></span>
                  </div>
                  <div class="fact-row" *ngIf="mode !== 'new' && workVisit.requestedDate">
                    <span class="k">Requested by</span><span class="v">{{ workVisit.requestedBy }}</span>
                  </div>
                  <div class="fact-row" *ngIf="mode !== 'new' && workVisit.requestedDate">
                    <span class="k">Requested date</span><span class="v">{{ workVisit.requestedDate | date : 'longDate' }}</span>
                  </div>
                  <div class="fact-row" *ngIf="mode !== 'new' && workVisit.updatedBy">
                    <span class="k">Updated by</span><span class="v">{{ workVisit.updatedBy }}</span>
                  </div>
                  <div class="fact-row" *ngIf="mode !== 'new' && workVisit.updatedBy">
                    <span class="k">Updated date</span><span class="v">{{ workVisit.updatedDate | date : 'longDate' }}</span>
                  </div>
                </div>
                <div *ngIf="workVisit.status && workVisit.status !== 'Requested' && workVisit.status !== 'Draft'"
                     class="wv-standard-response"
                     [class.wv-response-good]="workVisit.status === 'Authorized'"
                     [class.wv-response-bad]="workVisit.status === 'Rejected' || workVisit.status === 'Cancelled'">
                  <div *ngIf="workVisit.status === 'Authorized'">
                    Your work visit request for {{ workVisit.dateFrom | date :'longDate' }}
                    to {{ workVisit.dateTo | date :'longDate' }}
                    has been completed. Thank you for your understanding to provide the necessary
                    paperwork needed for access.
                    A completed work visit cannot be updated.
                  </div>
                  <div *ngIf="workVisit.status === 'Rejected' || workVisit.status === 'Cancelled'">
                    Work visits for this service require a valid Certificate of Insurance (COI) to be on
                    file per the Hosting Terms Addendum, Section 3.8 Insurance.
                    Please submit your current COI to the Onboarding Team: <a
                    href="mailto:{{onBoardingAddress}}">{{ onBoardingAddress }}</a>.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="mode !== 'new' && workVisit.status !== 'Draft' && jiraComments && jiraComments.length > 0"
               class="col-12 col-md-12 col-lg-12">
            <app-jira-comments [jiraComments]="jiraComments"></app-jira-comments>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!loading" class="col-12 d-flex justify-content-end wv-actions">
    <div *roles="['ROLE_MCKAY']" class="margin-left-5" style="padding-right: 12px;">
      <button [routerLink]="'/hosting/' + workVisit.clientId" class="btn btn-outline-secondary"
              type="button"><i aria-hidden="true" class="fa fa-arrow-left pr-2"></i>Back to list
      </button>
    </div>
    <div *roles="['ROLE_CLIENT']" class="margin-left-5" style="padding-right: 12px;">
      <button class="btn btn-outline-secondary" routerLink="/hosting"
              type="button"><i aria-hidden="true" class="fa fa-arrow-left pr-2"></i>Back to list
      </button>
    </div>
    <div *ngIf="mode !== 'new' && workVisit.status !== 'Rejected'" class="margin-left-5"
         style="padding-right: 12px;">
      <button (click)="cancelWorkVisit()"
              class="btn btn-outline-danger"><i aria-hidden="true" class="fa fa-close pr-2"></i>Cancel work visit
      </button>
    </div>
    <div class="margin-left-5">
      <ng-container *ngIf="mode === 'show'">
        <button *ngIf="workVisit.status === 'Rejected' && !getIsMckayUser()"
                [routerLink]="'/work-visit/edit/' + workVisit.id"
                class="btn btn-outline-primary">
          <i aria-hidden="true" class="fa fa-pencil pr-2"></i>Edit work visit
        </button>
      </ng-container>

      <ng-container *ngIf="mode !== 'show'">
        <button (click)="addOrEditWorkVisit(mode === 'new', true)" *ngIf="mode === 'new'"
                [disabled]="!canSubmit()"
                class="btn btn-outline-primary"
                style="margin-right: 12px;">
          <i aria-hidden="true" class="fa fa-clock-o pr-2"></i>Save draft
        </button>
        <button (click)="addOrEditWorkVisit(mode === 'new', false)" [disabled]="!canSubmit()"
                class="btn btn-outline-success">
          <i aria-hidden="true" class="fa fa-plus-circle pr-2"></i>Save and submit
        </button>
      </ng-container>
    </div>
  </div>
</div>
